const AuthQueryKeys = {
  user: (id: string) => ["auth", "user", id] as const,
};

export { AuthQueryKeys };
